import { Flex } from '@chakra-ui/core'
import * as React from 'react'
import { Programmes } from '../../generated/graphql'
import { H2 } from '../../typography'
import { Bar } from 'react-chartjs-2'

type WeeklyActivityProps = {
  programmes?: Programmes[]
}

const WeeklyActivity: React.FC<WeeklyActivityProps> = () => {
  const data = {
    datasets: [
      {
        backgroundColor: '#F4A807',
        highlightFill: '#98989880',
        barPercentage: 0.5,
        barThickness: 12,
        borderRadius: 4,
        categoryPercentage: 0.5,
        data: [8, 5, 1, 2, 2, 1, 2],
        maxBarThickness: 10
      }
    ],
    labels: ['M', 'T', 'W', 'T', 'F', 'S', 'S']
  }

  const options = {
    cornerRadius: 20,
    layout: { padding: 2 },
    maintainAspectRatio: false,
    responsive: true,
    grid: {
      display: false
    },
    plugins: {
      legend: { display: false }
    },
    scales: {
      x: {
        grid: {
          display: false
        }
      },
      y: {
        grid: {
          display: false
        }
      }
    },
    xAxes: [
      {
        ticks: {
          fontColor: '#3F51B5'
        },
        gridLines: {
          display: false
        }
      }
    ],
    yAxes: [
      {
        ticks: {
          fontColor: '#2F2F2F',
          beginAtZero: true,
          min: 0
        },
        gridLines: {
          display: false
        }
      }
    ],
    tooltips: {
      backgroundColor: '#989898',
      bodyFontColor: '#2F2F2F',
      enabled: true,
      footerFontColor: '#2F2F2F',
      intersect: false,
      mode: 'index',
      titleFontColor: '#2F2F2F'
    }
  }

  const plugins = [
    {
      id: `data-1`,
      // @ts-ignore
      beforeDraw: function (chart) {
        if (chart.chartArea) {
          const ctx = chart.ctx
          const chartArea = chart.chartArea
          const barArray = chart.getDatasetMeta(0).data

          ctx.fillStyle = '#98989880'

          for (let i = 0; i < barArray.length; i++) {
            const { x, width } = barArray[i]

            ctx.fillRect(x - width / 2, chartArea.top, width, chartArea.bottom - chartArea.top)
          }
        }
      }
    }
  ]
  return (
    <Flex flexDirection="column" width="515px" mt="34px">
      <H2 fontWeight={600} color="#989898" fontSize="16px">
        Weekly activity
      </H2>
      <Flex
        h="243px"
        align="center"
        justify="center"
        flexDirection="column"
        mt="14px"
        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.2);"
        borderRadius="8px"
        px="8px"
        className="weeklyActivity"
        py="23px"
      >
        <Bar data={data} options={options} plugins={plugins} />
      </Flex>
    </Flex>
  )
}

export default WeeklyActivity
